import React, { useState, useContext } from "react";
import axios from "axios";
import { Form, Button, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../assests/css/customer/ContactForm.css";
import AppContext from "../../../../context/AppContext";

const ContactForm = () => {
  const { regExpChecker } = useContext(AppContext);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const submitCustomerData = () => {
    const emailError = regExpChecker("email", email);
    if (emailError) { setErrorMessage(emailError); return; }

    setErrorMessage("");
    setLoading(true);
    setSuccessMessage("");

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("message", message);

    axios
      .post("http://localhost:8000/api/Customer/ContactForm/submitData", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("Response:", response.data);
        if (response.data.success === true) {
          setSuccessMessage("Thank you for contacting us! We'll get back to you soon.");
          setName("");
          setEmail("");
          setSubject("");
          setMessage("");
          setTimeout(() => setSuccessMessage(""), 5000);
        } else {
          alert(response.data.message || "Something went wrong.");
        }
      })
      .catch((error) => {
        console.log("Error:", error);
        alert("Something went wrong. Please try again later.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="contact-wrapper">

      {/* LEFT GOOGLE MAP */}
      <div className="contact-left">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217813.19566184914!2d73.91858644785156!3d32.15688450683594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391f29bcd973731b%3A0x4!2sGujranwala%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1707318000000!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Gujranwala Map"
        />
      </div>

      {/* DIAGONAL SHAPE */}
      <div className="diagonal-shape"></div>

      {/* RIGHT FORM */}
      <div className="contact-right">
        <h1 className="contact-heading">CONTACT NOW</h1>

        {successMessage && (
          <Alert variant="success" className="success-message">
            {successMessage}
          </Alert>
        )}

        <Form>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="YOUR NAME"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="contact-input"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              placeholder="EMAIL"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorMessage(regExpChecker("email", e.target.value));
              }}
              className="contact-input"
            />
            {errorMessage && <p style={{ color: "red", fontSize: "13px", marginTop: "4px" }}>{errorMessage}</p>}
          </Form.Group>


          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="SUBJECT"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="contact-input"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="MESSAGE"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="contact-textarea"
            />
          </Form.Group>

          <Button
            type="button"
            className="submit-btn"
            disabled={loading}
            onClick={submitCustomerData}
          >
            {loading ? "SUBMITTING..." : "SUBMIT"}
          </Button>
        </Form>
      </div>

    </div>
  );
};

export default ContactForm;